<div class="awards-months">
  <p-carousel #monthlyStatsCarousel [numVisible]="1" [value]="awardsSummary?.earnedPoints">
    <ng-template let-driverStat pTemplate="item">
      <app-expandable-panel class="carousel-expandable-header" [cardType]="true">
        <div class="month">
          <div class="caret" (click)="monthlyStatsCarousel.navBackward()">
            <fa-icon [icon]="['fas', 'caret-left']"></fa-icon>
          </div>

          <span
            >{{ driverStat.qualifyPeriod | date: 'MMMM' }}
            {{
              '(' +
                driverStat.finalBonus +
                (driverStat.finalBonus === 1 ? ' point' : ' points') +
                ' earned)'
            }}</span
          >

          <div class="caret" (click)="monthlyStatsCarousel.navForward()">
            <fa-icon [icon]="['fas', 'caret-right']"></fa-icon>
          </div>
        </div>
      </app-expandable-panel>
      <app-expandable-panel [cardType]="true">
        <div class="month-details">
          <div class="card">
            <fa-icon [icon]="['fal', 'clipboard-list-check']"></fa-icon>
            <p>Commitments, Huddles, Safety Video</p>
            <hr />
            <img
              [src]="
                'assets/iconCRE_sot-' +
                (driverStat.finalCommitBonus ? '' : 'un') +
                'checked_red-700.svg'
              "
            />
          </div>
          <div class="card">
            <fa-icon [icon]="['fal', 'shipping-timed']"></fa-icon>
            <p>On-Time, DVIR, Paperwork</p>
            <hr />
            <img
              [src]="
                'assets/iconCRE_sot-' +
                (driverStat.finalOnTimeBonus ? '' : 'un') +
                'checked_red-700.svg'
              "
            />
          </div>
          <div class="card">
            <fa-icon [icon]="['fal', 'car-crash']"></fa-icon>
            <p>No Accidents, Critical Events, or Log/CSA Violations</p>
            <hr />
            <img
              [src]="
                'assets/iconCRE_sot-' +
                (driverStat.finalSafeBonus ? '' : 'un') +
                'checked_red-700.svg'
              "
            />
          </div>
        </div>
      </app-expandable-panel>
    </ng-template>
  </p-carousel>
</div>
